{
  "apiServerUrl": "https://dev.adr.ienergy.halliburton.com",
  "authProvider": "Entra"
}
